<template>
  <div style="width:100%">
    <a-form layout="inline">
      <a-select placeholder="省/市" v-model="model.province" @change="selectProvince" style="width: 130px" allowClear :disabled="disabled">
        <a-select-option v-for="(item,index) in provinceArr" :key="index" :value="item.province">
          {{ item.province }}
        </a-select-option>
      </a-select>
      <a-select placeholder="市" v-model="model.city" @change="selectCity" style="width: 130px" allowClear :disabled="disabled">
        <a-select-option v-for="(item,index) in cityArr" :key="index" :value="item.city">
          {{ item.city }}
        </a-select-option>
      </a-select>
      <a-select placeholder="区/县" v-model="model.county" @change="selectCounty" style="width: 130px" allowClear :disabled="disabled">
        <a-select-option v-for="(item,index) in countyArr" :key="index" :value="item.area">
          {{ item.area }}
        </a-select-option>
      </a-select>
    </a-form>
  </div>
</template>
<script>

import { provinces } from './province'

export default {
  name: 'AreaSelect',
  components: {
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    provinceValue: String,
    cityValue: String,
    countyValue: String
  },
  watch: {
    provinceValue (newVal) {
      if (newVal) {
        const record = provinces.find(item => item.province == newVal)
        this.cityArr = record.data
        this.model.province = newVal
      } else {
        this.cityArr = []
        this.model.province = undefined
      }
    },
    cityValue (newVal) {
      if (newVal) {
        if (this.cityArr.length == 0 && this.provinceValue()) {
          const record = provinces.find(item => item.province == this.provinceValue)
          this.cityArr = record.data
        }
        const record = this.cityArr.find(item => item.city == newVal)
        this.countyArr = record.dataList
        this.model.city = newVal
      } else {
        this.countyArr = []
        this.model.city = undefined
      }
    },
    countyValue (newVal) {
      if (newVal) {
        this.model.county = newVal
      } else {
        this.model.county = undefined
      }
    }
  },
  data () {
    return {
      model: {
        province: null,
        city: null,
        county: null
      },
      provinceArr: [],
      cityArr: [],
      countyArr: []
    }
  },
  created () {
    this.provinceArr = provinces
  },
  mounted () { },
  methods: {
    selectProvince (val) {
      if (!val) {
        this.cityArr = []
        this.countyArr = []
        this.model.province = undefined
        this.model.city = undefined
        this.model.county = undefined
        this.$emit('change', this.model)
        return
      }
      const record = provinces.find(item => item.province == val)
      this.cityArr = record.data || []
      this.countyArr = []
      this.model.province = record.province
      this.model.city = undefined
      this.model.county = undefined
      this.$emit('change', this.model)
    },
    selectCity (val) {
      if (!val) {
        this.countyArr = []
        this.model.city = undefined
        this.model.county = undefined
        this.$emit('change', this.model)
        return
      }
      const record = this.cityArr.find(item => item.city == val)
      this.countyArr = record.dataList || []
      this.model.city = record.city
      this.model.county = undefined
      this.$emit('change', this.model)
    },
    selectCounty(val) {
      this.model.county = val
      this.$emit('change', this.model)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/infocollect/components/AreaSelect.vue